"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getSystemViewsQueryOptions, type SystemView } from "@/queries/system-views/fetchers";

/**
 * Fetches system views for pickers.
 * Without `workspaceId`, returns the optional system catalog.
 * With `workspaceId`, returns views that can still be added to that workspace.
 */
export function useSystemViews(workspaceId) {
  const $ = _c(17);
  let t0;
  if ($[0] !== workspaceId) {
    t0 = getSystemViewsQueryOptions(workspaceId);
    $[0] = workspaceId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const queryOptions = t0;
  const t1 = useQuery(queryOptions as UseQueryOptions<SystemView[]>);
  let error;
  let loading;
  let refresh;
  let rest;
  let t2;
  if ($[2] !== t1) {
    ({
      data: t2,
      error,
      isLoading: loading,
      refetch: refresh,
      ...rest
    } = t1);
    $[2] = t1;
    $[3] = error;
    $[4] = loading;
    $[5] = refresh;
    $[6] = rest;
    $[7] = t2;
  } else {
    error = $[3];
    loading = $[4];
    refresh = $[5];
    rest = $[6];
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const views = t3;
  let t4;
  if ($[10] !== error || $[11] !== loading || $[12] !== queryOptions || $[13] !== refresh || $[14] !== rest || $[15] !== views) {
    t4 = {
      ...rest,
      error,
      loading,
      queryOptions,
      refresh,
      views
    };
    $[10] = error;
    $[11] = loading;
    $[12] = queryOptions;
    $[13] = refresh;
    $[14] = rest;
    $[15] = views;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}